import React from 'react';

const Content = ({ children }) => (
	<div className="login-box-body">
		{children}
	</div >
)

export default Content;




// WEBPACK FOOTER //
// ./src/layouts/public/content/Content.js